export const fakeData = {
    "objetosFinanciables" : [ {
        "id" : 1,
        "nombre" : "Maquinaria y/o Implementos Agrícolas",
        "informacionExtra" : "Recordá que financiamos tanto maquinaria importada como nacional",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 1,
            "nombre" : "Agrícola"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 2,
        "nombre" : "Labores Culturales",
        "informacionExtra" : "",
        "ocultoStartUp" : true,
        "categoriaObjetoFinanciable" : {
            "id" : 1,
            "nombre" : "Agrícola"
        },
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        }
    }, {
        "id" : 3,
        "nombre" : "Mejoras, Refacción y/o Construcción",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 1,
            "nombre" : "Agrícola"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 4,
        "nombre" : "Insumos y/o Materia Prima",
        "informacionExtra" : "",
        "ocultoStartUp" : true,
        "categoriaObjetoFinanciable" : {
            "id" : 1,
            "nombre" : "Agrícola"
        },
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        }
    }, {
        "id" : 5,
        "nombre" : "Reconversión de Viñedos y/o Frutales",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 1,
            "nombre" : "Agrícola"
        },
        "linea" : {
            "id" : 2,
            "nombre" : "Inversión Reconversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 6,
        "nombre" : "Implantación de cultivos",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 1,
            "nombre" : "Agrícola"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 7,
        "nombre" : "Equipos de Riego y/u Obras Complementarias",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 2,
            "nombre" : "Eficiencia Hídrica"
        },
        "linea" : {
            "id" : 3,
            "nombre" : "Eficiencia Hídrica",
            "enlaceExterno" : "https://www.ftyc.gob.ar/eficiencia-hidrica/"
        }
    }, {
        "id" : 8,
        "nombre" : "Ampliación y/o Refacción de Equipos de Riego",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 2,
            "nombre" : "Eficiencia Hídrica"
        },
        "linea" : {
            "id" : 3,
            "nombre" : "Eficiencia Hídrica",
            "enlaceExterno" : "https://www.ftyc.gob.ar/eficiencia-hidrica/"
        }
    }, {
        "id" : 9,
        "nombre" : "Construcción, Arreglo y/o Reemplazo de Perforaciones",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 2,
            "nombre" : "Eficiencia Hídrica"
        },
        "linea" : {
            "id" : 3,
            "nombre" : "Eficiencia Hídrica",
            "enlaceExterno" : "https://www.ftyc.gob.ar/eficiencia-hidrica/"
        }
    }, {
        "id" : 10,
        "nombre" : "Construcción de Represa o Reservorio",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 2,
            "nombre" : "Eficiencia Hídrica"
        },
        "linea" : {
            "id" : 3,
            "nombre" : "Eficiencia Hídrica",
            "enlaceExterno" : "https://www.ftyc.gob.ar/eficiencia-hidrica/"
        }
    }, {
        "id" : 11,
        "nombre" : "Energía Sustentable",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 2,
            "nombre" : "Eficiencia Hídrica"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 12,
        "nombre" : "Malla Antigranizo",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 3,
            "nombre" : "Malla Antigranizo"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 13,
        "nombre" : "Adquisición de Ganado Bovino apto para Reproducción",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 4,
            "nombre" : "Ganadería"
        },
        "linea" : {
            "id" : 5,
            "nombre" : "Inversión Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        }
    }, {
        "id" : 14,
        "nombre" : "Adquisición de Ganado Bovino apto para Recría o Engorde",
        "informacionExtra" : "",
        "ocultoStartUp" : true,
        "categoriaObjetoFinanciable" : {
            "id" : 4,
            "nombre" : "Ganadería"
        },
        "linea" : {
            "id" : 6,
            "nombre" : "Capital de Trabajo Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        }
    }, {
        "id" : 15,
        "nombre" : "Maquinaria Ganadera",
        "informacionExtra" : "Recordá que financiamos tanto maquinaria importada como nacional",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 4,
            "nombre" : "Ganadería"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 16,
        "nombre" : "Infraestructura, Mejoras, Refacción y/o Construcción",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 4,
            "nombre" : "Ganadería"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 17,
        "nombre" : "Gastos de evolución (destete precoz, alimentos, vacunas, combustibles, mano de obra)",
        "informacionExtra" : "",
        "ocultoStartUp" : true,
        "categoriaObjetoFinanciable" : {
            "id" : 4,
            "nombre" : "Ganadería"
        },
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        }
    }, {
        "id" : 18,
        "nombre" : "Instalación Sistema de Riego y/u Obras Complementarias",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 4,
            "nombre" : "Ganadería"
        },
        "linea" : {
            "id" : 3,
            "nombre" : "Eficiencia Hídrica",
            "enlaceExterno" : "https://www.ftyc.gob.ar/eficiencia-hidrica/"
        }
    }, {
        "id" : 19,
        "nombre" : "Implantación de Pasturas Anuales",
        "informacionExtra" : "",
        "ocultoStartUp" : true,
        "categoriaObjetoFinanciable" : {
            "id" : 4,
            "nombre" : "Ganadería"
        },
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        }
    }, {
        "id" : 20,
        "nombre" : "Implantación de Pasturas Perennes",
        "informacionExtra" : "Los plazos de devolución del crédito pueden variar según el tipo de cultivo",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 4,
            "nombre" : "Ganadería"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 21,
        "nombre" : "Maquinaria Industrial",
        "informacionExtra" : "Recordá que financiamos tanto maquinaria importada como nacional",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 5,
            "nombre" : "Industria"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 22,
        "nombre" : "Mejoras, Refacción y/o Construcción",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 5,
            "nombre" : "Industria"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 23,
        "nombre" : "Insumos y/o Materia Prima",
        "informacionExtra" : "",
        "ocultoStartUp" : true,
        "categoriaObjetoFinanciable" : {
            "id" : 5,
            "nombre" : "Industria"
        },
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        }
    }, {
        "id" : 24,
        "nombre" : "Equipamiento Informático, Desarrollo Web y/o Software",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 5,
            "nombre" : "Industria"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 25,
        "nombre" : "Energía Sustentable",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 5,
            "nombre" : "Industria"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 26,
        "nombre" : "Equipamiento Informático, Desarrollo Web y/o Software",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 6,
            "nombre" : "Turismo"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 27,
        "nombre" : "Equipamiento, Mejoras, Refacción y/o Construcción",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 6,
            "nombre" : "Turismo"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 28,
        "nombre" : "Insumos y/o Materia Prima",
        "informacionExtra" : "",
        "ocultoStartUp" : true,
        "categoriaObjetoFinanciable" : {
            "id" : 6,
            "nombre" : "Turismo"
        },
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        }
    }, {
        "id" : 29,
        "nombre" : "Energía Sustentable",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 6,
            "nombre" : "Turismo"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 30,
        "nombre" : "Vehículo para Turismo",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 6,
            "nombre" : "Turismo"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 31,
        "nombre" : "Equipamiento, Mejoras, Refacción y/o Construcción",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 7,
            "nombre" : "Comercio y Servicios"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 32,
        "nombre" : "Insumos y/o Materia Prima",
        "informacionExtra" : "Recordá que en el FTyC no financiamos bienes de cambio (mercadería)",
        "ocultoStartUp" : true,
        "categoriaObjetoFinanciable" : {
            "id" : 7,
            "nombre" : "Comercio y Servicios"
        },
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        }
    }, {
        "id" : 33,
        "nombre" : "Equipamiento Informático, Desarrollo Web y/o Software",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 7,
            "nombre" : "Comercio y Servicios"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 34,
        "nombre" : "Energía Sustentable",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 7,
            "nombre" : "Comercio y Servicios"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    }, {
        "id" : 35,
        "nombre" : "Transporte Escolar",
        "informacionExtra" : "",
        "ocultoStartUp" : false,
        "categoriaObjetoFinanciable" : {
            "id" : 7,
            "nombre" : "Comercio y Servicios"
        },
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        }
    } ],
    "sectoresEconomicos" : [ {
        "id" : 1,
        "nombre" : "Agropecuario"
    }, {
        "id" : 2,
        "nombre" : "Construcción"
    }, {
        "id" : 3,
        "nombre" : "Industria y Minería"
    }, {
        "id" : 4,
        "nombre" : "Comercio"
    }, {
        "id" : 5,
        "nombre" : "Servicio"
    } ],
    "detallesLineas" : [ {
        "id" : 1,
        "porcentajeInversion" : 80.00,
        "topeSMVM" : 100.00,
        "porcentajeTasaNominalAnualBNA" : 30.00,
        "mesesPlazoDevolucion" : 60,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 1,
            "nombre" : "Micro Agro",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 2,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 300.00,
        "porcentajeTasaNominalAnualBNA" : 50.00,
        "mesesPlazoDevolucion" : 60,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 2,
            "nombre" : "Micro",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 3,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 500.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 60,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 3,
            "nombre" : "Pequeña 1",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 4,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 600.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 60,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 4,
            "nombre" : "Pequeña",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 5,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 800.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 60,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 5,
            "nombre" : "Mediana Tramo 1",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 6,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 1600.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 60,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 1,
            "nombre" : "Inversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 6,
            "nombre" : "Mediana Tramo 2",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 7,
        "porcentajeInversion" : 80.00,
        "topeSMVM" : 100.00,
        "porcentajeTasaNominalAnualBNA" : 30.00,
        "mesesPlazoDevolucion" : 84,
        "mesesGracia" : 36,
        "linea" : {
            "id" : 2,
            "nombre" : "Inversión Reconversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 1,
            "nombre" : "Micro Agro",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 8,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 300.00,
        "porcentajeTasaNominalAnualBNA" : 50.00,
        "mesesPlazoDevolucion" : 84,
        "mesesGracia" : 36,
        "linea" : {
            "id" : 2,
            "nombre" : "Inversión Reconversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 2,
            "nombre" : "Micro",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 9,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 500.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 60,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 2,
            "nombre" : "Inversión Reconversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 3,
            "nombre" : "Pequeña 1",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 10,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 600.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 60,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 2,
            "nombre" : "Inversión Reconversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 4,
            "nombre" : "Pequeña",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 11,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 800.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 60,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 2,
            "nombre" : "Inversión Reconversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 5,
            "nombre" : "Mediana Tramo 1",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 12,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 1600.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 60,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 2,
            "nombre" : "Inversión Reconversión",
            "enlaceExterno" : "https://www.ftyc.gob.ar/inversion/"
        },
        "categoriaEmpresa" : {
            "id" : 6,
            "nombre" : "Mediana Tramo 2",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 13,
        "porcentajeInversion" : 80.00,
        "topeSMVM" : 175.00,
        "porcentajeTasaNominalAnualBNA" : 30.00,
        "mesesPlazoDevolucion" : 120,
        "mesesGracia" : 24,
        "linea" : {
            "id" : 3,
            "nombre" : "Eficiencia Hídrica",
            "enlaceExterno" : "https://www.ftyc.gob.ar/eficiencia-hidrica/"
        },
        "categoriaEmpresa" : {
            "id" : 1,
            "nombre" : "Micro Agro",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 14,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 300.00,
        "porcentajeTasaNominalAnualBNA" : 50.00,
        "mesesPlazoDevolucion" : 120,
        "mesesGracia" : 24,
        "linea" : {
            "id" : 3,
            "nombre" : "Eficiencia Hídrica",
            "enlaceExterno" : "https://www.ftyc.gob.ar/eficiencia-hidrica/"
        },
        "categoriaEmpresa" : {
            "id" : 2,
            "nombre" : "Micro",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 15,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 500.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 96,
        "mesesGracia" : 24,
        "linea" : {
            "id" : 3,
            "nombre" : "Eficiencia Hídrica",
            "enlaceExterno" : "https://www.ftyc.gob.ar/eficiencia-hidrica/"
        },
        "categoriaEmpresa" : {
            "id" : 3,
            "nombre" : "Pequeña 1",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 16,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 600.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 96,
        "mesesGracia" : 24,
        "linea" : {
            "id" : 3,
            "nombre" : "Eficiencia Hídrica",
            "enlaceExterno" : "https://www.ftyc.gob.ar/eficiencia-hidrica/"
        },
        "categoriaEmpresa" : {
            "id" : 4,
            "nombre" : "Pequeña",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 17,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 800.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 96,
        "mesesGracia" : 24,
        "linea" : {
            "id" : 3,
            "nombre" : "Eficiencia Hídrica",
            "enlaceExterno" : "https://www.ftyc.gob.ar/eficiencia-hidrica/"
        },
        "categoriaEmpresa" : {
            "id" : 5,
            "nombre" : "Mediana Tramo 1",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 18,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 1600.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 96,
        "mesesGracia" : 24,
        "linea" : {
            "id" : 3,
            "nombre" : "Eficiencia Hídrica",
            "enlaceExterno" : "https://www.ftyc.gob.ar/eficiencia-hidrica/"
        },
        "categoriaEmpresa" : {
            "id" : 6,
            "nombre" : "Mediana Tramo 2",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 19,
        "porcentajeInversion" : null,
        "topeSMVM" : 50.00,
        "porcentajeTasaNominalAnualBNA" : 30.00,
        "mesesPlazoDevolucion" : 15,
        "mesesGracia" : 6,
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        },
        "categoriaEmpresa" : {
            "id" : 1,
            "nombre" : "Micro Agro",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        } ]
    }, {
        "id" : 20,
        "porcentajeInversion" : null,
        "topeSMVM" : 150.00,
        "porcentajeTasaNominalAnualBNA" : 50.00,
        "mesesPlazoDevolucion" : 15,
        "mesesGracia" : 6,
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        },
        "categoriaEmpresa" : {
            "id" : 2,
            "nombre" : "Micro",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        } ]
    }, {
        "id" : 21,
        "porcentajeInversion" : null,
        "topeSMVM" : 300.00,
        "porcentajeTasaNominalAnualBNA" : 75.00,
        "mesesPlazoDevolucion" : 15,
        "mesesGracia" : 6,
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        },
        "categoriaEmpresa" : {
            "id" : 3,
            "nombre" : "Pequeña 1",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        } ]
    }, {
        "id" : 22,
        "porcentajeInversion" : null,
        "topeSMVM" : 400.00,
        "porcentajeTasaNominalAnualBNA" : 100.00,
        "mesesPlazoDevolucion" : 15,
        "mesesGracia" : 6,
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        },
        "categoriaEmpresa" : {
            "id" : 4,
            "nombre" : "Pequeña",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        } ]
    }, {
        "id" : 23,
        "porcentajeInversion" : null,
        "topeSMVM" : 800.00,
        "porcentajeTasaNominalAnualBNA" : 100.00,
        "mesesPlazoDevolucion" : 15,
        "mesesGracia" : 6,
        "linea" : {
            "id" : 4,
            "nombre" : "Capital de Trabajo",
            "enlaceExterno" : "https://www.ftyc.gob.ar/capital-de-trabajo/"
        },
        "categoriaEmpresa" : {
            "id" : 5,
            "nombre" : "Mediana Tramo 1",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        } ]
    }, {
        "id" : 24,
        "porcentajeInversion" : 80.00,
        "topeSMVM" : 100.00,
        "porcentajeTasaNominalAnualBNA" : 30.00,
        "mesesPlazoDevolucion" : 72,
        "mesesGracia" : 36,
        "linea" : {
            "id" : 5,
            "nombre" : "Inversión Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        },
        "categoriaEmpresa" : {
            "id" : 1,
            "nombre" : "Micro Agro",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 25,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 300.00,
        "porcentajeTasaNominalAnualBNA" : 50.00,
        "mesesPlazoDevolucion" : 72,
        "mesesGracia" : 36,
        "linea" : {
            "id" : 5,
            "nombre" : "Inversión Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        },
        "categoriaEmpresa" : {
            "id" : 2,
            "nombre" : "Micro",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 26,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 500.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 72,
        "mesesGracia" : 36,
        "linea" : {
            "id" : 5,
            "nombre" : "Inversión Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        },
        "categoriaEmpresa" : {
            "id" : 3,
            "nombre" : "Pequeña 1",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 27,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 600.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 72,
        "mesesGracia" : 36,
        "linea" : {
            "id" : 5,
            "nombre" : "Inversión Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        },
        "categoriaEmpresa" : {
            "id" : 4,
            "nombre" : "Pequeña",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 28,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 800.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 72,
        "mesesGracia" : 36,
        "linea" : {
            "id" : 5,
            "nombre" : "Inversión Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        },
        "categoriaEmpresa" : {
            "id" : 5,
            "nombre" : "Mediana Tramo 1",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 29,
        "porcentajeInversion" : 75.00,
        "topeSMVM" : 1600.00,
        "porcentajeTasaNominalAnualBNA" : 60.00,
        "mesesPlazoDevolucion" : 72,
        "mesesGracia" : 36,
        "linea" : {
            "id" : 5,
            "nombre" : "Inversión Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        },
        "categoriaEmpresa" : {
            "id" : 6,
            "nombre" : "Mediana Tramo 2",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        }, {
            "id" : 3,
            "nombre" : "Semestral",
            "cantidadMeses" : 6
        } ]
    }, {
        "id" : 30,
        "porcentajeInversion" : null,
        "topeSMVM" : 50.00,
        "porcentajeTasaNominalAnualBNA" : 30.00,
        "mesesPlazoDevolucion" : 24,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 6,
            "nombre" : "Capital de Trabajo Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        },
        "categoriaEmpresa" : {
            "id" : 1,
            "nombre" : "Micro Agro",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        } ]
    }, {
        "id" : 31,
        "porcentajeInversion" : null,
        "topeSMVM" : 150.00,
        "porcentajeTasaNominalAnualBNA" : 50.00,
        "mesesPlazoDevolucion" : 24,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 6,
            "nombre" : "Capital de Trabajo Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        },
        "categoriaEmpresa" : {
            "id" : 2,
            "nombre" : "Micro",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        } ]
    }, {
        "id" : 32,
        "porcentajeInversion" : null,
        "topeSMVM" : 300.00,
        "porcentajeTasaNominalAnualBNA" : 75.00,
        "mesesPlazoDevolucion" : 24,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 6,
            "nombre" : "Capital de Trabajo Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        },
        "categoriaEmpresa" : {
            "id" : 3,
            "nombre" : "Pequeña 1",
            "oculto" : true
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        } ]
    }, {
        "id" : 33,
        "porcentajeInversion" : null,
        "topeSMVM" : 400.00,
        "porcentajeTasaNominalAnualBNA" : 100.00,
        "mesesPlazoDevolucion" : 24,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 6,
            "nombre" : "Capital de Trabajo Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        },
        "categoriaEmpresa" : {
            "id" : 4,
            "nombre" : "Pequeña",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        } ]
    }, {
        "id" : 34,
        "porcentajeInversion" : null,
        "topeSMVM" : 800.00,
        "porcentajeTasaNominalAnualBNA" : 100.00,
        "mesesPlazoDevolucion" : 24,
        "mesesGracia" : 12,
        "linea" : {
            "id" : 6,
            "nombre" : "Capital de Trabajo Ganadería",
            "enlaceExterno" : "https://www.ftyc.gob.ar/ganaderia/"
        },
        "categoriaEmpresa" : {
            "id" : 5,
            "nombre" : "Mediana Tramo 1",
            "oculto" : false
        },
        "periodicidades" : [ {
            "id" : 1,
            "nombre" : "Mensual",
            "cantidadMeses" : 1
        }, {
            "id" : 2,
            "nombre" : "Trimestral",
            "cantidadMeses" : 3
        } ]
    } ],
    "categoriasAgricolas" : [ {
        "id" : 1,
        "nombre" : "Hasta 15 has.",
        "categoriaEmpresa" : {
            "id" : 1,
            "nombre" : "Micro Agro",
            "oculto" : true
        }
    }, {
        "id" : 2,
        "nombre" : "Más de 15 has. y hasta 30 has.",
        "categoriaEmpresa" : {
            "id" : 2,
            "nombre" : "Micro",
            "oculto" : false
        }
    }, {
        "id" : 3,
        "nombre" : "Más de 30 has. y hasta 50 has.",
        "categoriaEmpresa" : {
            "id" : 3,
            "nombre" : "Pequeña 1",
            "oculto" : true
        }
    }, {
        "id" : 4,
        "nombre" : "Más de 50 has. y hasta 80 has.",
        "categoriaEmpresa" : {
            "id" : 4,
            "nombre" : "Pequeña",
            "oculto" : false
        }
    }, {
        "id" : 5,
        "nombre" : "Más de 80 has. y hasta 100 has.",
        "categoriaEmpresa" : {
            "id" : 5,
            "nombre" : "Mediana Tramo 1",
            "oculto" : false
        }
    }, {
        "id" : 6,
        "nombre" : "Más de 100 has.",
        "categoriaEmpresa" : {
            "id" : 6,
            "nombre" : "Mediana Tramo 2",
            "oculto" : false
        }
    } ],
    "constantes" : {
        "id" : 1,
        "salarioMinimoVitalMovil" : 20587.50,
        "tasaNominalAnualBNA" : 40.85,
        "montoMaximoSimulacion" : 40400000.00
    }
}
